export const isTruthyOrZero = (value) => value || value === 0;
